import { createSelector } from 'reselect'

const getLessonsPicker = state => state.lessonsPicker
const getLibrary = state => state.myLibrary

const myLibraryLessonsPickerModalSelector = createSelector(
	[ getLessonsPicker, getLibrary ],
	(lessons_picker, myLibrary) => ({
		page: lessons_picker.page,
		search: lessons_picker.search,
		order_field: lessons_picker.order_field,
		order_type: lessons_picker.order_type,
		more: lessons_picker.more,
		folderUID: myLibrary.folderUID,
	})
)

export default myLibraryLessonsPickerModalSelector
